import type { PriceValueField, ServicePriceEntryPrice, ServicePriceResponse } from '@repo/types/service-price';

type PriceAmount = Required<Pick<ServicePriceEntryPrice, 'amount' | 'currencyCode'>>;

export const selectDeliveryServicePriceAmount = (
    servicePrice: ServicePriceResponse | undefined,
    priceField: PriceValueField,
    deliveryNo?: string
): PriceAmount | undefined => {
    const deliveryServicePrices = servicePrice?.deliveryServicePrices;
    if (!deliveryServicePrices || deliveryServicePrices.length === 0) {
        return;
    }

    const priceEntry = deliveryNo
        ? deliveryServicePrices.find((entry) => entry.deliveryServiceReference?.lineId === deliveryNo)
        : deliveryServicePrices[0];

    const priceData = priceEntry?.price;
    if (!priceData) {
        return;
    }

    const amount = priceData[priceField];
    const currencyCode = priceData.currencyCode;

    if (typeof amount !== 'number' || typeof currencyCode !== 'string') {
        return;
    }

    return { amount, currencyCode };
};
